import React from 'react'
import './backup-info-data.css'
import { format, isValid } from 'date-fns'
const BackUpInfoData = ({backUpInfosByMonth, allStudents}) => {
    const [selectedMonth, setSelectedMonth] = React.useState(false)
    const [schoolMap, setSchoolMap] = React.useState(false)

    React.useEffect(() => {
        getInstrumentsPerSchoolByMonth()
        console.log(selectedMonth)
        !selectedMonth && setSchoolMap(false)
    }, [selectedMonth])

    const getInstrumentsPerSchoolByMonth = () => {
        let myMap = {}
        allStudents.forEach((family) => {
            if(isValid(new Date(family.onboardDate))) {
                if(format(new Date(family.onboardDate), 'MMM yyyy') === selectedMonth) {
                    for(let i = 0; i < family.students.length; i++) {
                        for(let j = 0; j < family.students[i].instrumentList.length; j++) {
                            if(myMap[family.school]) {
                                if(myMap[family.school][family.students[i].instrumentList[j].parentInstrument]) {
                                    myMap[family.school][family.students[i].instrumentList[j].parentInstrument]++
                                } else {
                                    myMap[family.school][family.students[i].instrumentList[j].parentInstrument] = 1
                                }
                            } else {
                                myMap[family.school] = {}
                                myMap[family.school][family.students[i].instrumentList[j].parentInstrument] = 1
                            }
                        }
                    }
                }
            }
        })
        setSchoolMap(myMap)
    }

    return (
        <div>
            <h2 className='text-center'>Backup Info Students By Month</h2>
            <div className='grid grid-cols-12 w-9/12 mx-auto my-5 cursor-pointer'>
                {backUpInfosByMonth.map((backUpInfo, index) => (
                    <div key={index} onMouseEnter={() => setSelectedMonth(backUpInfo.month)} onMouseLeave={() => setSelectedMonth(false)} className='col-span-1 bg-blue-100 p-1 border-solid border-black border'>
                        <div className='text-xs'>{backUpInfo.month}</div>
                        <div className='text-lg font-bold'>{backUpInfo.total}</div>
                    </div>
                ))}
            </div>
            {schoolMap &&
                <div className='grid-cols-4'>
                   {Object.keys(schoolMap).map((school, index) => (
                        <div className='inline-block align-top col-span-1 mx-10 text-left'>
                            <div className='text-lg font-bold'>{school}</div>
                            <div>{Object.keys(schoolMap[school]).map((inst) => (<div>{inst}: {schoolMap[school][inst]}</div>))}</div>
                        </div>
                   ))}
                </div>
            }
        </div>
    )
}
export default BackUpInfoData;